import { useState, useRef } from 'react';
import JSZip from 'jszip';
import { kml } from '@tmcw/togeojson';

export default function KmzUploader({ onUploadSuccess }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const fileInputRef = useRef(null);

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setLoading(true);
    setError(null);

    try {
      let geojson = null;

      if (file.name.endsWith('.kml')) {
        // Read KML directly
        const text = await file.text();
        const dom = new DOMParser().parseFromString(text, 'text/xml');
        geojson = kml(dom);
      } else if (file.name.endsWith('.kmz')) {
        // Unzip KMZ
        const zip = new JSZip();
        const contents = await zip.loadAsync(file);
        
        // Find the first .kml file inside the zip (usually doc.kml)
        const kmlFile = Object.values(contents.files).find(f => f.name.endsWith('.kml'));
        if (!kmlFile) {
          throw new Error("No .kml file found inside the KMZ archive.");
        }
        
        const text = await kmlFile.async('text');
        const dom = new DOMParser().parseFromString(text, 'text/xml');
        geojson = kml(dom);
      } else {
        throw new Error("Please upload a .kml or .kmz file.");
      }

      if (geojson && onUploadSuccess) {
        onUploadSuccess(geojson);
      }
    } catch (err) {
      console.error(err);
      setError(err.message || 'Error parsing file.');
    } finally {
      setLoading(false);
      // Reset input
      if (fileInputRef.current) fileInputRef.current.value = '';
    }
  };

  return (
    <div style={{ marginBottom: '1rem' }}>
      <input 
        type="file" 
        accept=".kml,.kmz" 
        onChange={handleFileUpload} 
        ref={fileInputRef}
        style={{ display: 'none' }}
        id="kmz-upload"
      />
      <label 
        htmlFor="kmz-upload" 
        className="btn btn-secondary" 
        style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer' }}
      >
        {loading ? 'Processing...' : '📁 Upload KML/KMZ'}
      </label>
      {error && <p style={{ color: 'red', marginTop: '0.5rem', fontSize: '0.9rem' }}>{error}</p>}
    </div>
  );
}
